define('controllers/fieldTurnstile',[], function() {
    var controller = Marionette.Object.extend({

        initialize: function () {
            this.listenTo( nfRadio.channel( 'turnstile' ), 'init:model',      this.initTurnstile  );
            this.listenTo( nfRadio.channel( 'forms' ),     'submit:response', this.resetTurnstile );
            
            // Setup turnstile global functions and event bindings
            this.setupTurnstileGlobals();
            this.bindTurnstileEvents();
        },

       	initTurnstile: function ( model ) {
       		nfRadio.channel( 'turnstile' ).reply( 'update:response', this.updateResponse, this, model.id );
        },

        updateResponse: function( response, fieldID ) {
        	var model = nfRadio.channel( 'fields' ).request( 'get:field', fieldID );
			model.set( 'value', response );
            nfRadio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'required-error' );
        },

        resetTurnstile: function() {
			var turnstileID = 0;
			jQuery( '.cf-turnstile, .nf-cf-turnstile' ).each( function() {
				try {
					turnstile.reset( turnstileID );
				} catch( e ){
					// Silent fail
				}
				turnstileID++;
			} );
        },

        setupTurnstileGlobals: function() {
            var self = this;
            
            // Setup global callback function
            window.nfTurnstileCallback = function(token) {
                var completedWidget = null;
                jQuery(".cf-turnstile, .nf-cf-turnstile").each(function() {
                    if (this.querySelector("iframe")) {
                        completedWidget = this;
                        return false;
                    }
                });

                if (completedWidget && token) {
                    var fieldID = jQuery(completedWidget).data("fieldid");
                    var input = document.getElementById("nf-field-" + fieldID);
                    if (input) {
                        input.value = token;
                        jQuery(input).trigger("change");
                        jQuery(input).closest(".field-wrap").removeClass("nf-error");
                        jQuery(input).closest(".field-wrap").find(".nf-error-msg").remove();
                    }

                    if (typeof nfRadio !== "undefined" && nfRadio.channel) {
                        try {
                            nfRadio.channel("turnstile").request("update:response", token, fieldID);
                        } catch(e) {}
                    }
                }
            };

            // Setup global render function
            window.nfRenderTurnstile = function() {
                if (typeof turnstile === "undefined") {
                    setTimeout(window.nfRenderTurnstile, 100);
                    return;
                }

                var allTurnstileElements = jQuery(".cf-turnstile, .nf-cf-turnstile");

                if (allTurnstileElements.length === 0) {
                    setTimeout(function() {
                        window.nfRenderTurnstile();
                    }, 200);
                    return;
                }

                jQuery(".cf-turnstile:empty, .nf-cf-turnstile:empty").each(function() {
                    var element = this;
                    var sitekey = jQuery(element).data("sitekey");
                    var fieldId = jQuery(element).data("fieldid");

                    if (!sitekey) {
                        return;
                    }

                    try {
                        turnstile.render(element, {
                            sitekey: sitekey,
                            theme: jQuery(element).data("theme") || "auto",
                            size: jQuery(element).data("size") || "normal",
                            callback: function(token) {
                                var fieldID = jQuery(element).data("fieldid");
                                var input = document.getElementById("nf-field-" + fieldID);
                                if (input) {
                                    input.value = token;
                                    jQuery(input).trigger("change");
                                    jQuery(input).closest(".field-wrap").removeClass("nf-error");
                                    jQuery(input).closest(".field-wrap").find(".nf-error-msg").remove();
                                }

                                if (typeof nfRadio !== "undefined" && nfRadio.channel) {
                                    try {
                                        nfRadio.channel("turnstile").request("update:response", token, fieldID);
                                    } catch(e) {}
                                }
                            }
                        });
                    } catch(e) {}
                });
            };
        },

        bindTurnstileEvents: function() {
            var self = this;
            
            // Initial render attempt
            if (typeof window.nfRenderTurnstile === "function") {
                window.nfRenderTurnstile();
            }

            // Bind to document ready
            jQuery(document).ready(function() {
                setTimeout(window.nfRenderTurnstile, 100);
            });

            // Bind to Ninja Forms events
            jQuery(document).on("nfFormReady", function() {
                setTimeout(window.nfRenderTurnstile, 100);
            });

            if (typeof nfRadio !== "undefined") {
                try {
                    nfRadio.channel("form").on("render:view", function() {
                        setTimeout(window.nfRenderTurnstile, 100);
                    });
                } catch(e) {}
            }

            // Retry mechanism for delayed element appearance
            var retryCount = 0;
            var maxRetries = 10;
            var retryInterval = setInterval(function() {
                retryCount++;
                if (retryCount >= maxRetries) {
                    clearInterval(retryInterval);
                    return;
                }

                if (jQuery(".cf-turnstile, .nf-cf-turnstile").length > 0) {
                    window.nfRenderTurnstile();
                    clearInterval(retryInterval);
                }
            }, 500);
        }
    });

    return controller;
} );

